module.exports = __webpack_public_path__ + "assets/img/80.png?c3dd51e8d0f756f6fb6a8a97de8a8fe3";